import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { PivotPlainObject } from '../plainObjects/pivot.plainObject';
import { ExpressionColumnPlainObject } from '../plainObjects/expressionColumn.plainObject';
import { MatchFunctionUtil } from '../utils/matchFunction.util';
import { SchemaUtil } from '../utils/schema.util';

export class PivotVisitor extends BaseTransformationVisitor {
    private get _pivotTransformation(): PivotPlainObject {
        return this.transformation as PivotPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitAssignment(assignment: any): void {
        this.addPivotFunction(SchemaUtil.getColumnName(assignment.columnIdentifier()), this._getText(assignment.expression()));
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitBasicFunction(context: any): void {
        if (context.basicName().getText() === 'pivotBy') {
            const expressions = context.expression();
            if (expressions[0]) {
                this._pivotTransformation.pivotKeyColumn = expressions[0].getText();
            }
            if (expressions[1]) {
                MatchFunctionUtil.addPivotValues(this._pivotTransformation, expressions[1]);
            }
        } else if (context.basicName().getText() === 'groupBy') {
            MatchFunctionUtil.addGroupByColumns(this._pivotTransformation, context);
        } else {
            this.addPivotFunction('', context.getText());
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitMetaFunctionExpr(context: any): void {
        if (context.metafunction().basicName().getText() === 'groupBy') {
            MatchFunctionUtil.addGroupByColumns(this._pivotTransformation, context.metafunction());
        }
    }

    private addPivotFunction(colName: string, expression: string): void {
        const pivotFunction = new ExpressionColumnPlainObject();
        pivotFunction.name = colName;
        pivotFunction.expression = expression;
        this._pivotTransformation.columns.push(pivotFunction);
    }
}
